/**
 * HQ browser-session helpers.
 *
 * Production authentication is carried only by the backend's HttpOnly
 * `shelflife_session` cookie. JavaScript never persists or reads that token.
 * A tab-scoped bearer fallback exists solely for loopback development where
 * localhost and 127.0.0.1 can be different browser sites and an insecure
 * cross-site cookie would be rejected.
 */
const DEV_TOKEN_KEY = "shelflife_dev_session";

function isLoopback(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export function usesLocalDevelopmentBearer() {
  if (typeof window === "undefined") return false;
  try {
    const apiUrl = new URL(process.env.REACT_APP_BACKEND_URL, window.location.origin);
    return isLoopback(window.location.hostname) && isLoopback(apiUrl.hostname);
  } catch {
    return false;
  }
}

export function getDevelopmentBearerToken() {
  if (!usesLocalDevelopmentBearer()) return null;
  try {
    return window.sessionStorage.getItem(DEV_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setDevelopmentBearerToken(token) {
  if (!usesLocalDevelopmentBearer() || !token) return;
  try {
    window.sessionStorage.setItem(DEV_TOKEN_KEY, token);
  } catch {
    // A disabled/full sessionStorage does not weaken production cookie auth.
  }
}

export function clearDevelopmentBearerToken() {
  try {
    window.sessionStorage.removeItem(DEV_TOKEN_KEY);
  } catch {
    // Best effort during logout.
  }
}

export function clearLegacyPersistentToken() {
  try {
    window.localStorage.removeItem("shelflife_token");
  } catch {
    // Best effort migration from the historical localStorage session.
  }
}
